import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'sl_SI',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '87861841-fd9b-4dc5-ad4a-ce5acf4e8478',
  ''
);
